// extracted by mini-css-extract-plugin
export var footer = "new-layout-module--footer--a9ea1";
export var initialized = "new-layout-module--initialized--33fc2";
export var layout = "new-layout-module--layout--b66fc";
export var navBarSafeArea = "new-layout-module--navBarSafeArea--af34e";